import { render, staticRenderFns } from "./DashboardTicketsCard.html?vue&type=template&id=4d43028e&scoped=true&"
import script from "./DashboardTicketsCard.js?vue&type=script&lang=js&"
export * from "./DashboardTicketsCard.js?vue&type=script&lang=js&"
import style0 from "./DashboardTicketsCard.scss?vue&type=style&index=0&id=4d43028e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d43028e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBadge,VBtn,VCard,VCol,VIcon,VRow,VSkeletonLoader})
